import React, { FC } from 'react';

import { useLocation } from 'react-router-dom';
import AccessdeniedIcon from '../../static/svg/AccessdeniedIcon';

const AccessDenied: FC = () => {
  const location = useLocation()

  return (
    <>
  
      <div className="accessDeniedLayout d-flex align-items-center justify-content-center">
        <div className="px-4 py-5">
          <div className="row justify-content-center">
            <div className="col-md-12">
              <div className="p-3 text-center">
                <div className="accessDeniedFavicon mb-2">
                  <AccessdeniedIcon/>
                </div>
                <div className="accessDeniedTitle mb-2">Access denied</div>
                <h2 className="accessDeniedText">
                  {"You are not authorised to access this page"}
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>

  );
};

export default AccessDenied;